module.exports = __webpack_public_path__ + "static/media/Cats eyes 04_TYSKA-mixdown.4766b946.mp3";